import { FormatString } from '@components/FormatString';
import { SearchResult } from '@components/SearchResult';
import type { SearchResultsProps } from './types';

export const SearchResults: React.FC<SearchResultsProps> = ({ page, searchTerm }) => {
  if (!page.results || page.results.length < 1) {
    return (
      <h3>
        <FormatString
          formatString={page.noResultsText}
          replacementInfo={{
            SearchString: searchTerm,
          }}
        />
      </h3>
    );
  }

  return page.results.map((result, index: number) => <SearchResult headline={result.headline} listNumber={index + 1} searchTerm={searchTerm} snippet={result.snippet} url={result.url} key={`result-${result.url}`} />);
};
